<template>
  <modal>
    <template slot="modal-header">
      <div class="header-wrapper">
        <h2 class="section-heading">
          <template v-if="agencyId"
            >Edit office</template
          >
          <template v-else
            >Create new office</template
          >
        </h2>
        <close-button @closeModal="closeModal"></close-button>
      </div>
    </template>
    <template slot="modal-body">
      <vue-form :state="formState" @submit.prevent="">
        <validate
          class="form-group col-12 c__modal--title"
          :class="{ c__editable: $isAllowed('edit') }"
        >
          <field-messages class="invalid-feedback" name="title" show="$dirty && $invalid">
            <div slot="required">Organisation name is required</div>
          </field-messages>
          <input
            type="text"
            :readonly="!$isAllowed('edit')"
            required
            name="displayName"
            class="input-title"
            placeholder="Organisation Name"
            v-model="agency.displayName"
          />
          <div class="i__edit">
            <svg
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 53.3 53.3"
              style="enable-background:new 0 0 53.3 53.3;"
              xml:space="preserve"
            >
              <path
                d="M51.7,14.7L38.6,1.6c-0.8-0.8-2.2-0.8-3,0l-34,34C1.2,36,1,36.5,1,37.1v13.1c0,1.2,1,2.1,2.1,2.1h13.1
                                c0.6,0,1.1-0.2,1.5-0.6l34-34C52.5,16.9,52.5,15.5,51.7,14.7z M15.3,48h-10V38l2.2-2.2l10,10L15.3,48z M20.5,42.8l-10-10L37.1,6.2
                                l10,10L20.5,42.8z"
              />
            </svg>
          </div>
        </validate>
        <tabs
          :tabs="tabs"
          :currentTab="currentTab"
          :wrapper-class="'tabs'"
          :tab-class="'tab-item'"
          :tab-active-class="'active'"
          :line-class="'tab-active-line'"
          @onClick="changeTab"
        />
        <div class="tab-content">
          <div v-if="currentTab === 'tab1'">
            <div class="form-row">
              <div class="col-2 form-group">
                <logo-upload :logo="agency.imageLogo" ref="logoRef" />
              </div>
              <div class="col-10">
                <div class="form-row">
                  <div class="form-group col-12">
                    <input
                      type="text"
                      id="primaryContact"
                      :readonly="!$isAllowed('edit')"
                      class="form-control"
                      v-model="agency.primaryContact"
                    />
                    <label for="primaryContact">Organisation primary contact</label>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-12">
                    <input
                      type="email"
                      name=""
                      :readonly="!$isAllowed('edit')"
                      value=""
                      class="form-control"
                      v-model="agency.email"
                    />
                    <label>Email</label>
                  </div>
                  <div class="form-group col-12">
                    <input
                      type="text"
                      name=""
                      :readonly="!$isAllowed('edit')"
                      value=""
                      class="form-control"
                      v-model="agency.phone"
                    />
                    <label>Phone number</label>
                  </div>
                  <div class="form-group col-12">
                    <input
                      type="text"
                      name=""
                      :readonly="!$isAllowed('edit')"
                      value=""
                      class="form-control"
                      v-model="agency.postcode"
                    />
                    <label>Post Codes</label>
                  </div>
                  <div class="form-group col-12">
                    <input
                      type="text"
                      name=""
                      :readonly="!$isAllowed('edit')"
                      value=""
                      class="form-control"
                      v-model="agency.destinationUrl"
                    />
                    <label>Destination URL</label>
                  </div>
                  <div class="form-group col-12">
                    <input
                      type="text"
                      name=""
                      :readonly="!$isAllowed('edit')"
                      value=""
                      class="form-control"
                      v-model="agency.title"
                      disabled
                    />
                    <label style="text-transform: none !important;">agentID</label>
                  </div>
                  <div class="form-group col-12">
                    <input
                      type="text"
                      name=""
                      :readonly="!$isAllowed('edit')"
                      value=""
                      class="form-control"
                      v-model="agency.revId"
                    />
                    <label>REV ID</label>
                  </div>
                  <div class="form-group col-12">
                    <div class="form-row">
                      <div class="col-3">
                        <input
                          type="text"
                          name=""
                          value=""
                          class="form-control"
                          v-model="agency.backgroundColor"
                        />
                      </div>
                      <div class="col-3">
                        <input
                          type="color"
                          name=""
                          value=""
                          class="form-control col-3"
                          v-model="agency.backgroundColor"
                        />
                      </div>
                      <div class="col-6 label-wrapper">
                        <div class="c__checkbox">
                          <input type="checkbox" v-model="agency.organicCampaigns" />
                          <label>Enable Organic Social Posts</label>
                        </div>
                      </div>
                    </div>
                    <label>Brand Color</label>
                  </div>
                  <div class="form-group col-12">
                    <div class="form-row">
                      <div class="col-3">
                        <input
                          type="text"
                          name=""
                          value=""
                          class="form-control"
                          v-model="agency.secondaryColor"
                        />
                      </div>
                      <div class="col-3">
                        <input
                          type="color"
                          name=""
                          value=""
                          class="form-control col-3"
                          v-model="agency.secondaryColor"
                        />
                      </div>
                    </div>
                    <label>Secondary Color</label>
                  </div>
                </div>
              </div>
              <div class="col-12" style="display: none;">
                <h3 class="section-heading">Email Orders</h3>
                <div class="form-row">
                  <div class="form-group col-6">
                    <input
                      type="text"
                      id="emailRecipients"
                      class="form-control"
                      v-model="agency.ordersReport.recipients"
                      :readonly="!$isAllowed('edit')"
                    />
                    <div class="error" v-if="!isEmailListValid()">Invalid Email List</div>
                    <label for="emailRecipients">Recipients (comma separated)</label>
                  </div>
                  <div class="form-group col-6">
                    <div>
                      <label>Repeat on</label><br />
                      <div class="c__checkbox inline">
                        <input
                          id="Mon"
                          type="radio"
                          value="Mon"
                          v-model="agency.ordersReport.recurrencePattern.weekday"
                          :disabled="!$isAllowed('edit')"
                        />
                        <label class="round" for="Mon">Mon</label>
                      </div>
                      <div class="c__checkbox inline">
                        <input
                          id="Tue"
                          type="radio"
                          value="Tue"
                          v-model="agency.ordersReport.recurrencePattern.weekday"
                          :disabled="!$isAllowed('edit')"
                        />
                        <label class="round" for="Tue">Tue</label>
                      </div>
                      <div class="c__checkbox inline">
                        <input
                          id="Wed"
                          type="radio"
                          value="Wed"
                          v-model="agency.ordersReport.recurrencePattern.weekday"
                          :disabled="!$isAllowed('edit')"
                        />
                        <label class="round" for="Wed">Wed</label>
                      </div>
                      <div class="c__checkbox inline">
                        <input
                          id="Thu"
                          type="radio"
                          value="Thu"
                          v-model="agency.ordersReport.recurrencePattern.weekday"
                          :disabled="!$isAllowed('edit')"
                        />
                        <label class="round" for="Thu">Thu</label>
                      </div>
                      <div class="c__checkbox inline">
                        <input
                          id="Fri"
                          type="radio"
                          value="Fri"
                          v-model="agency.ordersReport.recurrencePattern.weekday"
                          :disabled="!$isAllowed('edit')"
                        />
                        <label class="round" for="Fri">Fri</label>
                      </div>
                      <div class="c__checkbox inline">
                        <input
                          id="Sat"
                          type="radio"
                          value="Sat"
                          v-model="agency.ordersReport.recurrencePattern.weekday"
                          :disabled="!$isAllowed('edit')"
                        />
                        <label class="round" for="Sat">Sat</label>
                      </div>
                      <div class="c__checkbox inline">
                        <input
                          id="Sun"
                          type="radio"
                          value="Sun"
                          v-model="agency.ordersReport.recurrencePattern.weekday"
                          :disabled="!$isAllowed('edit')"
                        />
                        <label class="round" for="Sun">Sun</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="currentTab === 'tab2'">
            <div class="form-row">
              <div
                class="col-12"
                v-if="
                  agentCampaignPaymentOption == 'credit-card' ||
                    propertyCampaignPaymentOption == 'credit-card' ||
                    officeCampaignPaymentOption == 'credit-card'
                "
              >
                <div class="space-between col-12 stripe-accepted-cards">
                  <h3>Payment Details - Credit Card</h3>
                  <div>
                    <img class="" src="../../assets/images/stripe_visa_light.png" />
                    <img class="" src="../../assets/images/stripe_mastercard_light.png" />
                    <img class="" src="../../assets/images/stripe_americanexpress_light.png" />
                  </div>
                </div>
                <div class="col-12 form-group" v-if="clientCards && clientCards.length > 0">
                  <div class="row">
                    <div class="col-2"></div>
                    <div class="col-10">
                      <div>{{ agency.client.title.toUpperCase() }} DEFAULT CARD</div>
                      <div
                        v-for="(card, index) in clientCards"
                        v-bind:key="index"
                        class="card-container space-between"
                      >
                        <span
                          >{{ card["brand"] }} **** **** **** {{ card["last4"] }} / Exp:
                          {{ card["exp_month"] }} - {{ card["exp_year"] }}</span
                        >
                        <!--<a href="#" @click.prevent="removeCard(card)">Remove</a>-->
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 form-group" v-else>
                  <div class="row">
                    <div class="col-2"></div>
                    <div class="col-10">
                      NO DEFAULT CARD SET FOR {{ agency.client.title.toUpperCase() }}
                    </div>
                  </div>
                </div>
                <div class="col-12 form-group" v-if="agencyCards && agencyCards.length > 0">
                  <div class="row">
                    <div class="col-2"></div>
                    <div class="col-10">
                      <div>{{ agency.displayName.toUpperCase() }} DEFAULT CARD</div>
                      <div
                        v-for="(card, index) in agencyCards"
                        v-bind:key="index"
                        class="card-container space-between"
                      >
                        <span
                          >{{ card["brand"] }} **** **** **** {{ card["last4"] }} / Exp:
                          {{ card["exp_month"] }} - {{ card["exp_year"] }}</span
                        >
                        <a href="#" @click.prevent="removeCard(card)">Remove</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 form-group" v-else>
                  <div class="row">
                    <div class="col-2"></div>
                    <div class="col-10">
                      If offices require a different credit card to the card set at client level,
                      they can override it below
                      <credit-card-save @saveCard="saveCard"></credit-card-save>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="col-12"
                v-if="
                  (agentCampaignPaymentOption == 'trading-terms' ||
                    propertyCampaignPaymentOption == 'trading-terms' ||
                    officeCampaignPaymentOption == 'credit-card') &&
                    agency.client.tradingTerms
                "
              >
                <div class="space-between col-12">
                  <h3>Payment Details - Trading Terms</h3>
                </div>
                <div class="col-12 form-group">
                  <div class="row">
                    <div class="col-12">
                      {{ agency.client.tradingTerms }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="currentTab === 'tab3'">
            <template>
              <div class="table-header">
                <h3 class="section-heading">Invite users</h3>
                <button type="button" class="btn-link" @click="openUserModal(null)">
                  Create user
                </button>
              </div>
            </template>
            <template>
              <section class="client-user-table">
                <table
                  class="table table-bordered"
                  v-if="agency.permissions && agency.permissions.data"
                >
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Username</th>
                      <th>Role</th>
                      <th>Active</th>
                      <th>Media Orders</th>
                      <th>Campaigns</th>
                      <th>Payment Details</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="agency.permissions.data">
                      <tr
                        v-for="permission in agency.permissions.data"
                        :key="permission.id"
                        :class="{
                          c__inactive: !permission.user.enabled,
                          disabled: permission.user.role.value === 'ROLE_AGENT_ADMIN'
                        }"
                      >
                        <td @click="openUserModal(permission.user)">
                          {{ permission.user.firstName }} {{ permission.user.lastName }}
                        </td>
                        <td @click="openUserModal(permission.user)">
                          {{ permission.user.username }}
                        </td>
                        <td @click="openUserModal(permission.user)">
                          {{ permission.user.role.name }}
                        </td>
                        <td>
                          <div class="c__checkbox">
                            <input
                              type="checkbox"
                              v-bind:checked="permission.user.enabled"
                              v-on:click.stop="changeUserStatus(permission.user, permission)"
                              :disabled="permission.user.role.value === 'ROLE_AGENT_ADMIN'"
                            />
                            <label>Active</label>
                          </div>
                        </td>
                        <td>
                          <div class="c__checkbox">
                            <input
                              type="checkbox"
                              v-model="permission.canViewMediaOrders"
                              @change="changePermission(permission)"
                              :disabled="
                                permission.user.role.value === 'ROLE_AGENT_ADMIN' ||
                                  !permission.permissionUpdatable
                              "
                            />
                            <label>View media orders</label>
                          </div>
                        </td>
                        <td>
                          <div class="c__checkbox">
                            <input
                              type="checkbox"
                              v-model="permission.canViewPastOrders"
                              @change="changePermission(permission)"
                              :disabled="
                                permission.user.role.value === 'ROLE_AGENT_ADMIN' ||
                                  !permission.permissionUpdatable
                              "
                            />
                            <label>View campaigns</label>
                          </div>
                        </td>
                        <td>
                          <div class="c__checkbox">
                            <input
                              type="checkbox"
                              v-model="permission.canViewPaymentDetails"
                              @change="changePermission(permission)"
                              :disabled="
                                permission.user.role.value === 'ROLE_AGENT_ADMIN' ||
                                  !permission.permissionUpdatable
                              "
                            />
                            <label>View Payment Details</label>
                          </div>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
                <table class="table table-bordered" v-else>
                  <tbody>
                    <tr>
                      <td>No user is added</td>
                    </tr>
                  </tbody>
                </table>
              </section>
            </template>
          </div>
          <div v-if="currentTab === 'tab4'">
            <template>
              <section class="client-user-table automate-report col-6">
                <p
                  class="report-row"
                  style="color: #13a3eb;text-align: left;font-style: italic;font-size: 13px;"
                  v-if="agency.automateReport && agency.automateReport.lastSent"
                >
                  Last report was sent on
                  {{ agency.automateReport.lastSent | formatDate("DD MMM YYYY") }}
                </p>
                <div class="report-row">
                  <label class="bold">Repeat every </label>
                  <input
                    type="number"
                    v-model="agency.automateReport.recurrencePattern.interval"
                    class="form-control inline ml-2"
                    min="1"
                  />
                  <select
                    class="form-control inline"
                    v-model="agency.automateReport.recurrencePattern.type"
                  >
                    <template v-if="agency.automateReport.recurrencePattern.interval == 1">
                      <option value="daily">day</option>
                      <option value="weekly">week</option>
                    </template>
                    <template v-else>
                      <option value="daily">days</option>
                      <option value="weekly">weeks</option>
                    </template>
                  </select>
                </div>
                <div
                  v-if="agency.automateReport.recurrencePattern.type == 'weekly'"
                  class="report-row"
                >
                  <label class="bold">Repeat on</label>
                  <div>
                    <div class="c__checkbox inline">
                      <input
                        id="Mon"
                        type="radio"
                        value="Mon"
                        v-model="agency.automateReport.recurrencePattern.weekday"
                      />
                      <label class="round" for="Mon">Mon</label>
                    </div>
                    <div class="c__checkbox inline">
                      <input
                        id="Tue"
                        type="radio"
                        value="Tue"
                        v-model="agency.automateReport.recurrencePattern.weekday"
                      />
                      <label class="round" for="Tue">Tue</label>
                    </div>
                    <div class="c__checkbox inline">
                      <input
                        id="Wed"
                        type="radio"
                        value="Wed"
                        v-model="agency.automateReport.recurrencePattern.weekday"
                      />
                      <label class="round" for="Wed">Wed</label>
                    </div>
                    <div class="c__checkbox inline">
                      <input
                        id="Thu"
                        type="radio"
                        value="Thu"
                        v-model="agency.automateReport.recurrencePattern.weekday"
                      />
                      <label class="round" for="Thu">Thu</label>
                    </div>
                    <div class="c__checkbox inline">
                      <input
                        id="Fri"
                        type="radio"
                        value="Fri"
                        v-model="agency.automateReport.recurrencePattern.weekday"
                      />
                      <label class="round" for="Fri">Fri</label>
                    </div>
                    <div class="c__checkbox inline">
                      <input
                        id="Sat"
                        type="radio"
                        value="Sat"
                        v-model="agency.automateReport.recurrencePattern.weekday"
                      />
                      <label class="round" for="Sat">Sat</label>
                    </div>
                    <div class="c__checkbox inline">
                      <input
                        id="Sun"
                        type="radio"
                        value="Sun"
                        v-model="agency.automateReport.recurrencePattern.weekday"
                      />
                      <label class="round" for="Sun">Sun</label>
                    </div>
                  </div>
                </div>
                <div
                  v-if="agency.automateReport.recurrencePattern.type == 'monthly'"
                  class="report-row"
                >
                  <label class="bold">Repeat </label>
                  <p class="">
                    Monthly on day
                    <select
                      class="form-control inline"
                      v-model="agency.automateReport.recurrencePattern.monthday"
                    >
                      <template v-for="index in 31">
                        <option :value="index">{{ index }}</option>
                      </template>
                    </select>
                  </p>
                </div>
                <div class="report-row row">
                  <div class="col-5">
                    <div class="mb-1">
                      <label class="bold mr-2">Starts</label>
                      <div class="date-time-picker-container inline">
                        <DateTimePicker
                          color="#13a3eb"
                          class="mr-sm-2"
                          noLabel
                          label="Select date"
                          formatted="DD MMM YYYY"
                          format="YYYY-MM-DD"
                          autoClose
                          input-size="sm"
                          v-model="agency.automateReport.recurrenceRange.start"
                          noButton
                          noClearButton
                          :no-value-to-custom-elem="false"
                          only-date
                        >
                        </DateTimePicker>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="report-row">
                  <div>
                    <label class="bold">Recipients</label>
                    <br />
                    <div
                      class="mb-1"
                      v-for="(recipient, index) in agency.automateReport.recipientLists"
                    >
                      <input
                        class="form-control inline no-m-l"
                        type="text"
                        v-model.trim="agency.automateReport.recipientLists[index]"
                      />
                      <button type="button" class="btn-remove" @click="removeRecipient(index)">
                        &times;
                      </button>
                    </div>
                    <div class="space-between">
                      <button class="btn-link mt-1 mb-2" @click="addRecipient">
                        Add recipient
                      </button>
                    </div>
                  </div>
                </div>
              </section>
            </template>
          </div>
        </div>
        <div class="modal-footer">
          <div class="c__btn--container">
            <button
              class="btn btn-tertiary"
              v-if="agencyId && $isAllowed('archive')"
              type="button"
              @click="deleteAction(`Are you sure you want to archive ${agency.displayName}?`, 'Archive')"
              :disabled="formState.$invalid || submitting"
            >
              Archive
            </button>
          </div>
          <template v-if="currentTab === 'tab1' || currentTab === 'tab2' || currentTab === 'tab3'">
            <button
              type="submit"
              v-if="$isAllowed('edit')"
              class="btn btn-primary"
              @click="saveAndContinue"
              :disabled="formState.$invalid || submitting"
            >
              Save + continue
            </button>
            <button type="submit" v-else class="btn btn-primary" @click="nextTab">Continue</button>
          </template>
          <template v-else>
            <div class="c__btn--container">
              <button
                class="btn btn-primary"
                v-if="$isAllowed('edit') || $isAllowed('updateAutomateReport')"
                @click="saveAgency('published')"
                :disabled="formState.$invalid || submitting"
                type="submit"
              >
                Save
              </button>
              <button class="btn btn-primary" v-else @click="closeModal" type="submit">
                Close
              </button>
            </div>
          </template>
        </div>
      </vue-form>
      <transition name="modal">
        <user-modal
          v-if="showUserModal"
          :agency="agency"
          :userId="agencyUserId"
          @closeModal="closeUserModal"
        ></user-modal>
      </transition>
      <result-message :errors="errors"></result-message>
    </template>
  </modal>
</template>

<script>
import Tabs from "vue-tabs-with-active-line";
import DateTimePicker from "vue-ctk-date-time-picker";

import Modal from "../../helpers/Modal";
import CloseButton from "../../helpers/CloseButton";
import LogoUpload from "../../helpers/LogoUpload";
import ResultMessage from "../../helpers/ResultMessage";

import UserModal from "./AgencyUserModal";

import AgencyServices from "../../services/agencies";
import UserServices from "../../services/users";
import PaymentServices from "../../services/payment";
import PackageServices from "../../services/packages";

import CreditCardSave from "../CreditCard/CreditCardSave";

import AgencyPerimeters from "../../configs/Perimeters/agencies";
import FileServices from "../../services/files";
import DeleteAction from "../../mixins/DeleteAction";

export default {
  perimeters: [AgencyPerimeters],
  mixins: [DeleteAction],
  name: "ModalAgency",
  props: {
    agencyId: {
      default: null
    }
  },
  components: {
    ResultMessage,
    CreditCardSave,
    Modal,
    Tabs,
    UserModal,
    LogoUpload,
    CloseButton,
    DateTimePicker
  },
  data() {
    return {
      errors: {
        type: Object | Error,
        $clean: true
      },
      formState: {},
      currentTab: "tab1",
      tabs: [
        {
          title: "Details",
          value: "tab1"
        }
      ],
      agency: {
        address: {},
        ordersReport: {
          recurrencePattern: {
            type: "weekly",
            interval: 1,
            weekday: "Mon",
            monthday: 15
          },
          recurrenceRange: {
            start: null
          },
          recipientLists: []
        },
        automateReport: {
          recurrencePattern: {
            type: "weekly",
            interval: 1,
            weekday: "Mon",
            monthday: 15
          },
          recurrenceRange: {
            start: null
          },
          recipientLists: []
        }
      },
      agencyUserId: null,
      showUserModal: false,
      created: false,
      agencyCards: [],
      clientCards: [],
      packages: [],
      emailListReg: /^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,4},?)+$/,
      agentCampaignPaymentOption: "",
      propertyCampaignPaymentOption: "",
      officeCampaignPaymentOption: "",
      submitting: false
    };
  },
  methods: {
    isEmailListValid: function() {
      return this.agency.ordersReport.recipients == "" ||
        typeof this.agency.ordersReport.recipients == "undefined"
        ? true
        : this.emailListReg.test(this.agency.ordersReport.recipients)
        ? true
        : false;
    },
    closeModal() {
      this.$emit("closeModal");
    },
    openUserModal(user) {
      if (user) {
        this.agencyUserId = user.id;
      }
      this.showUserModal = true;
    },
    closeUserModal() {
      this.agencyUserId = null;
      this.showUserModal = false;
      this.getAgency(this.agency.id);
    },
    nextTab() {
      if (this.currentTab === "tab1") {
        this.currentTab = "tab2";
      } else if (this.currentTab === "tab2") {
        this.currentTab = "tab3";
      } else if (this.currentTab === "tab3") {
        this.currentTab = "tab4";
      }
    },
    changeTab(tab) {
      this.currentTab = tab;
    },
    changePermission(permission) {
      AgencyServices.updatePermission(this.agency, permission).then(permission => {});
    },
    changeUserStatus(user, permission) {
      user.enabled = !user.enabled;
      if (typeof user.imageOriginal == "object") {
        user.imageOriginal = user.imageOriginal.id;
      }
      if (user.enabled) {
        user.selectedPermissions = [];
        user.selectedPermissions.push(this.agency.id);
        const updateUserObject = { ...user };
        updateUserObject.role = updateUserObject.role.value;
        UserServices.setAgencies([this.agency])
          .updateUser(updateUserObject)
          .then(updatedUser => {
            permission.permissionUpdatable = true;
          })
          .catch(errors => {
            this.errors = errors;
          });
      } else {
        permission.permissionUpdatable = false;
        permission.canViewMediaOrders = false;
        permission.canViewPastOrders = false;
        permission.canViewPaymentDetails = false;
        this.changePermission(permission);

        UserServices.deleteUser(user.id)
          .then(updatedUser => {})
          .catch(errors => {
            this.errors = errors;
          });
      }
    },
    getAgencyCards(agencyId) {
      PaymentServices.getAgencyCards(agencyId).then(cards => {
        if (cards) {
          this.agencyCards = cards;
        }
      });
    },
    saveCard(token) {
      let card = {
        token: token
      };
      PaymentServices.addCard(this.agency.id, card).then(cards => {
        this.getAgencyCards(this.agency.id);
      });
    },
    removeCard(card) {
      PaymentServices.deleteCard(this.agency.id, card).then(cards => {
        this.agencyCards = cards.data;
      });
    },
    getClientCards(clientId) {
      PaymentServices.getClientCards(clientId).then(cards => {
        if (cards) {
          this.clientCards = cards;
        }
      });
    },
    updateAgencyFields(agency) {
      if (typeof agency.ordersReport == "undefined") {
        this.agency.ordersReport = {
          recurrencePattern: {
            type: "weekly",
            interval: 1,
            weekday: "Mon",
            monthday: 15
          },
          recurrenceRange: {
            start: null
          },
          recipients: "",
          recipientLists: []
        };
      }

      if (agency.automateReport.recipients) {
        agency.automateReport.recipientLists = agency.automateReport.recipients.split(",");
      } else {
        agency.automateReport.recipientLists = [];
      }
      if (typeof agency.automateReport == "undefined") {
        this.agency.automateReport = {
          recurrencePattern: {
            type: "weekly",
            interval: 1,
            weekday: "Mon",
            monthday: 15
          },
          recurrenceRange: {
            start: null
          },
          recipients: "",
          recipientLists: []
        };
      }
      // Set permissions updatable flag
      if (agency.permissions && agency.permissions.data) {
        agency.permissions.data = agency.permissions.data.map(permission => ({
          ...permission,
          permissionUpdatable: permission.user.enabled
        }));
      }

      this.agency = agency;

      if (this.agency.permissions && this.agency.permissions.data) {
        this.agency.permissions.data.sort((a, b) =>
          a.user.firstName.toLowerCase() + a.user.lastName.toLowerCase() >
          b.user.firstName.toLowerCase() + b.user.lastName.toLowerCase()
            ? 1
            : b.user.firstName.toLowerCase() + b.user.lastName.toLowerCase() >
              a.user.firstName.toLowerCase() + a.user.lastName.toLowerCase()
            ? -1
            : 0
        );
      }

      if (!agency.displayName) {
        agency.displayName = agency.title;
      }

      if (agency.agentCampaignPaymentOption) {
        this.agentCampaignPaymentOption = agency.agentCampaignPaymentOption;
      } else {
        this.agentCampaignPaymentOption = agency.client.agentCampaignPaymentOption;
      }
      if (agency.propertyCampaignPaymentOption) {
        this.propertyCampaignPaymentOption = agency.propertyCampaignPaymentOption;
      } else {
        this.propertyCampaignPaymentOption = agency.client.propertyCampaignPaymentOption;
      }
      if (agency.officeCampaignPaymentOption) {
        this.officeCampaignPaymentOption = agency.officeCampaignPaymentOption;
      } else {
        this.officeCampaignPaymentOption = agency.client.officeCampaignPaymentOption;
      }
    },
    getAgency(agencyId) {
      AgencyServices.getAgency(
        agencyId,
        "address,automateReport,client,permissions,ordersReport"
      ).then(agency => {
        this.updateAgencyFields(agency);

        this.getAgencyCards(agency.id);
        this.getClientCards(agency.client.id);
      });
    },
    async updateAgency(formData, closeModal = true) {
      if (formData) {
        await this.uploadAgencyLogo(formData);
      } else if (this.agency.imageLogo) {
        this.agency.imageLogo = this.agency.imageLogo.id;
      }

      await AgencyServices.updateAgency(this.agency)
        .then(agency => {
          this.agency = agency;
          if (closeModal) {
            this.$emit("closeModal");
          } else {
            this.updateAgencyFields(agency);
          }
        })
        .catch(errors => {
          this.errors = errors;
        });
    },
    async createAgency(formData) {
      if (formData) {
        await this.uploadAgencyLogo(formData);
      }

      this.agency.title = this.agency.displayName;
      AgencyServices.createAgency(this.agency)
        .then(agency => {
          this.agency = agency;
          this.created = true;
        })
        .catch(errors => {
          this.errors = errors;
        });
    },
    async uploadAgencyLogo(formData) {
      await FileServices.uploadFile(formData)
        .then(imageLogo => {
          this.agency.imageLogo = imageLogo.id;
        })
        .catch(errors => {
          this.errors = errors;
        });
    },
    async saveAgency(status) {
      this.submitting = true;
      let formData = null;
      if (this.$refs.logoRef && typeof this.$refs.logoRef.uploadFile.size !== "undefined") {
        formData = new FormData();
        formData.append("image", this.$refs.logoRef.uploadFile);
        formData.append("subType", "logo");
      }
      this.agency.status = status;
      if (this.agency.automateReport && this.agency.automateReport.recipientLists) {
        this.agency.automateReport.recipients = this.agency.automateReport.recipientLists.toString();
      }
      await this.updateAgency(formData);
      this.submitting = false;
    },
    /**
     * A wrapper around the saveAgency() function to accommodate the
     * DeleteAction mixin callback.
     */
    deleteItem() {
      this.saveAgency("archive");
    },
    async saveAndContinue() {
      this.submitting = true;
      let formData = null;
      if (this.$refs.logoRef && typeof this.$refs.logoRef.uploadFile.size !== "undefined") {
        formData = new FormData();
        formData.append("image", this.$refs.logoRef.uploadFile);
        formData.append("subType", "logo");
      }
      if (this.currentTab === "tab1") {
        if (AgencyPerimeters.isAllowed("updateCreditCard")) {
          this.currentTab = "tab2";
        } else {
          this.currentTab = "tab3";
        }
        if (this.tabs[1]) {
          this.tabs[1].disabled = false;
        }
        if (this.tabs[2]) {
          this.tabs[2].disabled = false;
        }
        if (this.tabs[3]) {
          this.tabs[3].disabled = false;
        }
      } else if (this.currentTab === "tab2") {
        this.currentTab = "tab3";
      } else if (this.currentTab === "tab3") {
        this.currentTab = "tab4";
      }
      if (this.agency.automateReport && this.agency.automateReport.recipientLists) {
        this.agency.automateReport.recipients = this.agency.automateReport.recipientLists.toString();
      }
      if (!this.agencyId && !this.created) {
        await this.createAgency(formData);
      } else {
        await this.updateAgency(formData, false);
      }
      this.submitting = false;
    },
    getPackages(status) {
      PackageServices.setAgency()
        .getPackages(status)
        .then(packages => {
          let vue = this;
          this.packages = packages.data;
          this.packages.forEach(function(product) {
            vue.agency.packages.data.forEach(function(attachedPackage) {
              if (attachedPackage.id === product.id) {
                product.isAssigned = true;
              }
            });
          });
        });
    },
    updatePackage(product) {
      PackageServices.updatePackagePermission(product, this.agency).then(result => {});
    },
    addRecipient() {
      this.agency.automateReport.recipientLists.push("");
    },
    removeRecipient(index) {
      this.agency.automateReport.recipientLists.splice(index, 1);
    }
  },
  created() {
    if (AgencyPerimeters.isAllowed("updateCreditCard")) {
      this.tabs.push({
        title: "Payment Details",
        value: "tab2"
      });
    }
    this.tabs.push(
      {
        title: "Users",
        value: "tab3"
      },
      {
        title: "Campaign Report",
        value: "tab4"
      }
    );
    if (this.agencyId) {
      this.getAgency(this.agencyId);
    } else {
      this.tabs[1].disabled = true;
    }
  },
  mounted() {}
};
</script>
